var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.translationSource)?_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.bottomright",modifiers:{"bottomright":true}}],staticClass:"p-0 tooltip-button",class:_vm.translationSource,attrs:{"title":_vm.$t(`multilingual.${_vm.translationSource}`),"variant":"light-flat","data-qa":"translation tooltip"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }